import React, {  Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

/*Actions*/
import {
    updateRotatingBannersObject
} from '../../../redux/actions';

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showLoader:false,
			selectedIndex: 1,
        }
    }

	componentDidMount() {
		const self = this;
		var myInt = setInterval(() => {
			const { homepage } = self.props;
			if(window.location.pathname !== '/home') {
				clearInterval(myInt);
			}
			if(homepage && homepage.rotatingBanners) {
				let selectedIndex = self.state.selectedIndex + 1;
				let customerType;
				if (self.props.isGEAPartsSalesAgreementSelected()) {
					customerType = 'PARTS';
				} else {
					customerType = self.props.getSelectedAccountType();
					if (customerType === 'PRO CHANNEL'){
						customerType = 'PRO';
					}
					if (customerType === 'HQ') {
						customerType = 'CONTRACT';
					}
				}
				if(selectedIndex > homepage.rotatingBanners[customerType.toLowerCase()].length) {
					selectedIndex = 1;
				}
				self.setState({
					selectedIndex
				});
				// move first banner to end so that it will update in component to make infinite rotation of banner
				const temp = JSON.parse(JSON.stringify(homepage.rotatingBanners[customerType.toLowerCase()]));
				if(temp[selectedIndex - 2]) {
					temp.push(temp[selectedIndex - 2]);
				}
				self.props.updateRotatingBannersObject({
					data: temp,
					customerType: customerType.toLowerCase()
				});
			}
		}, 6000);
	}

    fireGTMTag(tagName, navElementText, navURL) {
        this.props.fireGTMTag(tagName, {
            navURL,
            navElementText
        });
    }

    render() {
		let customerType = this.props.getSelectedAccountType();
		if (customerType === 'PRO CHANNEL'){customerType = 'PRO';}
		if (customerType === 'HQ') {customerType = 'CONTRACT';}
		let agreementType = this.props.isGEAPartsSalesAgreementSelected();
		if(agreementType === true){customerType = 'parts';}
        const { homepage } = this.props;
		const { rotatingBanners = [], contentSlot = [] } = homepage || {};
        return (
            <div>
                <div className="heroBanner carousel carousel-slider" id="heroBannerGeospring">
                    <div className="slider-wrapper axis-horizontal">
						<ul className="slider animated" style={{transform: `translate3d(${(this.state.selectedIndex - 1) * 100 * -1}%, 0px, 0px)`, transitionDuration: '1000ms'}}>
							{rotatingBanners[customerType.toLowerCase()] && rotatingBanners[customerType.toLowerCase()].map((slot, index) => {
		                        // const title = slot.attributes && _.find(slot.attributes, ["name", "Title"]).values[0].value,
		                        //     imageURL = slot.attributes && _.find(slot.attributes, ["name", "Image"]).values[0].value;
		                        return <li key={index} className={"slide "+(this.state.selectedIndex + 1 === index ?"selected":"")}>
									<div title={slot.description}>
										<img className="height-144" src={slot.imageLink} alt={slot.description} title={slot.description} />
									</div>
		                        </li>
		                    })}
						</ul>
                    </div>
					<div className="clear"></div>
                </div>
                <div className="homePageSlots">
                    {contentSlot[customerType.toLowerCase()] && contentSlot[customerType.toLowerCase()].map((slot, index) => {
                        const {
							redirectURL,
							imageLink,
							description,
							assetName
						} = slot;
                        return <div key={index} className={"homePageSlot txt-ctr slot"+index}>
							<div className="image height-144">
                            <a href={redirectURL} onClick={this.fireGTMTag.bind(this, 'Home Page Links', redirectURL, _.unescape(assetName))} target="_blank">
									<span className="helper"></span>
									<img className="height-width-ratio" src={imageLink} alt={_.unescape(assetName)} title={_.unescape(assetName)} />
								</a>
							</div>
							<div className="text">
								<h3>
									<a href={redirectURL} onClick={this.fireGTMTag.bind(this, 'Home Page Links', redirectURL, _.unescape(assetName))} target="_blank">{_.unescape(assetName)}</a>
								</h3>
								<p>{_.unescape(description)}</p>
							</div>
                        </div>
                    })}
                    <div className="clear"></div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
	return {
		homepage: state.homepage
	};
};

const mapDispatchToProps = (dispatch) => ({
	updateRotatingBannersObject: (data) => dispatch(updateRotatingBannersObject(data))
});

Home = connect(mapStateToProps, mapDispatchToProps)(Home);
export default Home;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Home/index.js